export enum ProviderActionsTypes {
  READ = "@@PROVIDER read",
  READ_STATUS = "@@PROVIDER read status",
  UPDATE_ONE = "@@PROVIDER update one",
  SET_SHEET_SUPPLIER = "@@PROVIDER set as sheet supplier"
}
